<div class="production-db-content" dir="{{languageDir}}">
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
  </div>
  <div *ngIf="formHtml" [innerHTML]="formHtml" #contentToConvert></div>
  <div *ngIf="!formHtml" class="no-data-found" style="display: flex; justify-content: center; align-items: center; height: 40vh;">
    <div class="no-data-found-text" style="text-align: center;">
      <i class="fas fa-info-circle" style="font-size: 48px; color: blue;"></i>
      <div style="font-weight: bold; animation: fadeIn 2s; margin-top: 10px;">
        The page you are looking for is not yet published.
        Please check back later or contact support for more information.
      </div>
    </div>
  </div>
</div>